import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormatSize } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from "framer-motion";
import { MARKS, FONT_SIZE_OPTIONS } from '../../../constants';
import PopupWrapper from '../../PopupWrapper';

class FontSize extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.sizeOnClick = this.sizeOnClick.bind(this);
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  sizeOnClick(event) {
    event.preventDefault();
    const size = Number(event.currentTarget.dataset.size);

    // first find all font size marks on the selected text and remove them
    this.props.value.marks.forEach(mark => {
      const currentMarkSize = mark.data.get('size');
      this.props.editor.removeMark({
        type: MARKS.FONT_SIZE,
        data: { size: currentMarkSize },
      });
    });

    // then add the new incoming font size mark
    if (size !== 'Default') {
      this.props.editor.addMark({ type: MARKS.FONT_SIZE, data: { size } });
    }

    this.togglePopup();
  }

  render() {
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--fontsize">
          <button
            title="Text Size"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <FormatSize />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
            <motion.div
              initial={{ opacity: 0, y: '80%' }}
              animate={{ opacity: 1, y: '100%' }}
              exit={{ opacity: 0, y: '80%' }}
              transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
              className="icon__popup icon__popup--fontsize icon__popup--range">
              <ul
                ref={ul => (this.ul = ul)}
                className="list-reset m-0 overflow-y-scroll">
                {FONT_SIZE_OPTIONS.map(size => {
                  return (
                    <li key={size}>
                      <button
                        data-size={size}
                        onClick={this.sizeOnClick}
                        className="bg-white border-0 px-4 py-2 text-sm w-full outline-none cursor-pointer">
                        {size}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  FontSize;
